import config from '@/config/config'
import { DateTime, Settings } from 'luxon'

/* always use CET time zone! */
Settings.defaultZoneName = 'Europe/Vienna'
Settings.defaultLocale = config.language

function asDateTime(isoDate: string): DateTime {
  return DateTime.fromISO(isoDate)
}

function now() {
  return DateTime.now()
}

function withDay(dateTime: DateTime, newDay: number) {
  return DateTime.fromObject({
    year: dateTime.year,
    month: dateTime.month,
    day: newDay,
    hour: dateTime.hour,
    minute: dateTime.minute
  })
}
function withYear(dateTime: DateTime, newYear: number) {
  return DateTime.fromObject({
    year: newYear,
    month: dateTime.month,
    day: dateTime.day,
    hour: dateTime.hour,
    minute: dateTime.minute
  })
}

function isCurrentMonth(date: DateTime){
  return now().month === date.month && now().year === date.year
}

export {
  asDateTime,
  now,
  withDay,
  withYear,
  isCurrentMonth
}
